import React from "react";
//outsource
import { Row, Col, Typography, Checkbox } from "antd";

//components
//redux
import { useDispatch, useSelector } from "react-redux";
import { setPhotos, setLocation } from "../../../../store/report/report.action";

const { Title } = Typography;

const TimeShow = () => {
  // -------------------------- VAR --------------------------
  const options = [
    { value: "photos", label: "Show photos" },
    { value: "location", label: "Show location" },
  ];
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();

  // -------------------------- FUNCTION --------------------------
  const handleChange = (value) => {
    if (value?.includes("photos")) {
      dispatch(setPhotos({ data: true }));
    } else {
      dispatch(setPhotos({ data: false }));
    }

    if (value?.includes("location")) {
      dispatch(setLocation({ data: true }));
    } else {
      dispatch(setLocation({ data: false }));
    }
  };
  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return <Checkbox.Group options={options} onChange={handleChange} />;
};

export default TimeShow;
